import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import React from 'react';

import { Grid } from '@mui/material';
import { DehydratedState, Hydrate, QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AppProps } from 'next/app';
import Head from 'next/head';
import { AppViewport } from 'src/v2/components/layout/app';
import { VestaProviders } from 'src/v2/components/layout/app/providers';
import { AppSidebar } from 'src/v2/components/layout/app/sidebar';
import { AppTopnav } from 'src/v2/components/layout/app/topnav';

import { UnsupportedNetworkModal } from '~components/app/UnsupportedNetworkModal';

export const queryClient = new QueryClient();

const MyApp = ({ Component, pageProps }: AppProps<{ dehydratedState: DehydratedState }>) => {
  return (
    <>
      <Head>
        <title>Vesta Finance - DeFi Lending Platform</title>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#000000" />
        <meta
          name="description"
          content="Vesta Finance is a DeFi lending protocol on the Arbitrum network. Maximize the potential of popular crypto assets such as ETH, BTC, gOHM, DPX, and GMX by taking out interest free loans."
        />
      </Head>

      <div>
        <VestaProviders>
          <Hydrate state={pageProps.dehydratedState}>
            <ReactQueryDevtools initialIsOpen={true} />
            <Grid container height={'100%'}>
              <AppSidebar />
              <UnsupportedNetworkModal />
              <AppTopnav />
              <AppViewport Component={Component} pageProps={pageProps} />
            </Grid>
          </Hydrate>
        </VestaProviders>
      </div>
    </>
  );
};

export default MyApp;
